import { render } from "./Confirm_email.vue?vue&type=template&id=4f3e7cb5&scoped=true"
import script from "./Confirm_email.vue?vue&type=script&lang=js"
export * from "./Confirm_email.vue?vue&type=script&lang=js"

import "./Confirm_email.vue?vue&type=style&index=0&id=4f3e7cb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3e7cb5"]])

export default __exports__